/**
 * Created by lzy 19-11-04
 * 添加百家号账号模块
 */
'use strict';
angular.module('productManageMentBaijiahaoAccountAddModule', []).controller('ProductManageMentBaijiahaoAccountAddCtrl', ['$scope', '$modalInstance', '$validation', 'trsHttpService', 'item',
    function($scope, $modalInstance, $validation, trsHttpService, item) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            // $scope.data = {
            //     currUser: {
            //         sinaLoginUserName: ''
            //     }
            // };
            $scope.data = {
                currUser: {
                    baiJiaHaoAccountName: item ? item.ACCOUNTNAME : '',
                    baiJiaHaoAccountId: item ? item.BAIJIAHAOACCOUNTID : 0,
                    appId: item ? item.APPID : '',
                    appToken: item ? item.APPTOKEN : '',
                    ISPAICHONG: item ? item.ISPAICHONG : '0',
                    CKMSIMDAYRANGE: item ? item.CKMSIMDAYRANGE : '',
                    serviceId: 'mlf_baijiahaoconfig',
                    methodName: item ? 'editBaiJiaHaoAccount' : 'saveBaiJiaHaoAccount',
                }
            };
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            // var params = {
            //     serviceid: 'mlf_baijiahaoconfig',
            //     methodName: 'saveBaiJiaHaoAccount',
            //     baiJiaHaoAccountName: $scope.data.currUser.appName,
            //     appId: $scope.data.currUser.appId,
            //     appToken: $scope.data.currUser.appToken
            //     // scope: 'user_info,video.create,aweme.share'
            //     // sinaUserLoginPwd: $scope.data.currUser.sinaUserLoginPwd,
            //     // is_original: $scope.data.currUser.is_original
            // };
            $scope.accountForm.$pending = {};
            $validation.validate($scope.accountForm).success(function() {
                LazyLoad.js(['./lib/js-base64/base64.js'], function() {
                    // params.sinaUserLoginPwd = Base64.encode(angular.copy($scope.data.currUser.sinaUserLoginPwd));
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', $scope.data.currUser, 'post', true).then(function(data) {
                        $modalInstance.close({result: true});
                    }, function(data) {
                        $modalInstance.close({result: false, data: data});
                    });
                });
            });
        };
    }]);
